import Vue from 'vue'
import Router from 'vue-router'
import common_routers from './common_routers'
import store from '../store/index'
import * as CONST from '@/constants.js'

Vue.use(Router)
var router = new Router({
  mode: 'history',
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  base: '',
  routes: common_routers,
})

function routeCheck(to, from, next) {
  const webUserToken = localStorage.getItem('webuser_token')
  if (to.meta.authRequired) {
    if (!store.getters.is_customer_logged_in && !webUserToken) {
      next({
        name: 'home',
        query: {
          showLogin: true,
        },
      })
      return false
    }
  }
  return true
}

function setupConfig(to) {
  // this will help to get store details
  if (to.params.store_id) {
    store.commit('SET_STORE_ID_URL', to.params.store_id)
  }
  if (to.params.product_id) {
    store.commit('SET_PRODUCT_ID', to.params.product_id)
  }
  if (to.params.order_id) {
    let floorTable = localStorage.getItem('getFloorTableInformation')
    if (floorTable && floorTable.length > 5) {
      // we are saving order_id for update order, currently we need it only for dine in,
      store.commit('SET_ORDER_ID', to.params.order_id)
      store.commit('SET_DINEIN_FLOOR_TABLE', JSON.parse(floorTable))
      store.commit('SET_ORDER_TYPE', CONST.ORDER_TYPE_DINEIN)
    }
    let areasTables = JSON.parse(localStorage.getItem('areas_tables'))
    if (areasTables) {
      store.commit('SET_DINEIN_AREAS', areasTables.areas)
      store.commit('SET_DINEIN_TABLES', areasTables.tables)
    }
  }
  if (to.params.floor_id) {
    let floorTable = {
      table_id: to.params.table_id,
      floor_id: to.params.floor_id,
    }
    // store.dispatch('_getFloorTableInformation', floorTable)
    store.commit('SET_DINEIN_FLOOR_TABLE', floorTable)
    store.commit('SET_ORDER_TYPE', CONST.ORDER_TYPE_DINEIN)
  }
}

//Note: brandwebsite ll not set context in router.js for brand and store as it is already set in login / init_Store
router.beforeEach(async (to, from, next) => {
  if (!routeCheck(to, from, next)) {
    return false
  }
  setupConfig(to)
  next()
})

router.beforeResolve((to, from, next) => {
  Vue.nextTick(() => {
    store.dispatch('resetCollections')
  })
  next()
})

router.afterEach((to, from) => {
  console.log('route end', to, from)
})
Vue.router = router

export default router
